import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectShowReportModal = createSelector(
  [(store: RootState) => store.documentsList.showReportModal],
  (data) => data
);
